/**
 * form-embed D2 — the forms plug-in: a studio's general forms on its website, sent by
 * guests and by signed-in visitors. Its switch is `site-forms`; the website itself also
 * needs `web-site`. It comes with the Shop (Gabriel 2026-10-26: "Shop will be a paid
 * feature and those two included with shop"). Its routes, admin page, piece and page
 * join this declaration as each is built (tasks 4.4, 6.x and 7.x), so `pnpm
 * plugins:check` and the API's boot check stay green at every step.
 */
import { definePlugin } from './define.js';

export const formsPlugin = definePlugin({
  id: 'forms',
  name: 'Forms on your site',
  description:
    "Puts the studio's general forms on its website. Signed-in visitors just send; guests add a name and email, which match or create a client without Telegram.",
  paidAddOn: false,
  includedWith: 'shop',
  feature: 'site-forms',
  pieces: ['site-form'],
  pages: ['site-form'],
  // form-embed D8: the Telegram offer over a guest's name and email, in each site's own words (card 4's
  // mechanism, the shape the shop's offer takes): a heading, an optional lead and one to six benefits.
  siteOptions: {
    signInOffer: {
      kind: 'group',
      description: 'The offer to sign in with Telegram, shown to a guest above the name and email fields.',
      fields: {
        heading: { kind: 'text', maxLength: 60, description: 'Its heading.' },
        lead: { kind: 'text', maxLength: 200, optional: true, description: 'A line under the heading.' },
        benefits: {
          kind: 'list',
          min: 1,
          max: 6,
          description: 'What signing in gives the visitor.',
          item: {
            kind: 'group',
            description: 'One benefit: a line, with a few words in bold before it if the site wants.',
            fields: {
              title: { kind: 'text', maxLength: 60, optional: true, description: 'A few words in bold.' },
              line: { kind: 'text', maxLength: 200, description: "The benefit in a sentence; {studio} is the studio's name." },
              // form-embed D12: a benefit that promises a reply shows only on a form that asks where to reply.
              when: {
                kind: 'choice',
                values: ['always', 'askingWhereToReply'],
                optional: true,
                description: 'When it shows: always (the default), or askingWhereToReply, only on a form that asks where to reply.',
              },
            },
          },
        },
      },
      default: {
        heading: 'Sign in with Telegram',
        benefits: [
          { line: "{studio} talks with clients in Telegram, so it's the fastest way to hear back.", when: 'askingWhereToReply' },
          { line: "You won't need to type your name or email." },
        ],
      },
    },
  },
  siteRoutes: {
    prefix: '/api/site/forms',
    routes: [
      { method: 'GET', url: '/api/site/forms/:key' },
      { method: 'POST', url: '/api/site/forms/:key/send' },
      // site-form-buy-mode D2: a form placed with a product holds its answers for the purchase.
      { method: 'POST', url: '/api/site/forms/:key/hold' },
    ],
  },
  adminRoutes: {
    prefix: '/api/admin/site-forms',
    routes: [
      { method: 'GET', url: '/api/admin/site-forms/:formId' },
      { method: 'PUT', url: '/api/admin/site-forms/:formId' },
    ],
  },
  adminSections: [],
  noticeTypes: [],
  clientMessageTypes: [],
  emailKinds: [],
  services: [],
});
